import styled from 'styled-components';
import NumIconSmOutline from '../NumIconSmOutline';

const NumIconLight = styled(NumIconSmOutline)`
  opacity: 0.4;
`;

export default NumIconLight;
